import { observable } from 'mobx';

export type MarginResponseArgs = {
  amount: number;
};

export type MarginArgs = {
  amount: number;
};

export const convertMarginResponseToArgs = (response: MarginResponseArgs) => {
  const args: MarginArgs = {
    amount: response.amount
  };
  return args;
};

export default class Margin {
  @observable amount: number;

  constructor(args: MarginArgs) {
    this.amount = args.amount;
  }
}
